import React from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

function ToastContent({ closeToast, productName, leadTimeLabel }) {
  const navigate = useNavigate();

  const handleGoToCart = () => {
    navigate('/carrinho');
    closeToast();
  };

  const handleContinueShopping = () => {
    closeToast();
  };

  return (
    <div className="toast-premium">
      <div className="toast-premium-morph-icon" aria-hidden="true">
        <FaShoppingCart />
      </div>

      <div className="toast-premium-title">Adicionado ao carrinho</div>
      {productName && <div className="toast-premium-subtitle">{productName}</div>}
      <div className="toast-premium-alert">
        {leadTimeLabel
          ? `Importante: este item precisa de ${leadTimeLabel} de antecedência para entrega ou retirada.`
          : 'Este item está configurado como pronta entrega.'}
      </div>

      <div className="toast-premium-actions">
        <button className="btn btn-primary btn-sm" onClick={handleGoToCart}>
          Ver carrinho
        </button>

        <button className="btn btn-outline-primary btn-sm" onClick={handleContinueShopping}>
          Continuar
        </button>
      </div>
    </div>
  );
}

export default ToastContent;
